export const isValidCasePath = (path: string) => {
  const id = path.split('/case?id=')[1];
  return id ? id.length === 36 : false;
};
